import type { AddIndexResReadPointAssetHistoryType } from '@/types';

export default function RewardHistory({ history }: { history: AddIndexResReadPointAssetHistoryType[] }) {
  if (history.length === 0) {
    return (
      <>
        <div className="mt-[17px] flex items-center gap-[5px] px-[17px]"></div>
        <div className="mt-[11px] pl-[17px] pr-[10px]">
          <div className="yellow-scrollbar flex h-[calc(100dvh-512px)] flex-col gap-[6px] overflow-y-auto pr-[9px]"></div>
        </div>
      </>
    );
  }
  return (
    <>
      <div className="mt-[17px] flex items-center gap-[5px] px-[17px]">
        <div className="mb-[3px] h-[8px] w-[8px] rounded-full bg-white" />
        <h3 className="text-[15px] font-[800] text-white">REWARD HISTORY</h3>
      </div>

      <div className="mt-[11px] pl-[17px] pr-[10px]">
        <div className="yellow-scrollbar flex h-[calc(100dvh-512px)] flex-col gap-[6px] overflow-y-auto pr-[9px]">
          {history.map((item) => (
            <div
              key={item.reward_id}
              className={`rounded-4xl 'font-bold' flex items-center gap-[6px] border-2 border-[#FF6839] bg-white px-[17px] py-[12px] text-[10px] text-[#4F4F4F]`}
            >
              <span>No.{item.index}</span>
              <div className="h-[14px] w-[1px] bg-[#B2B2B2]"></div>
              <span>{item.reward_dt}</span>
              <div className="h-[14px] w-[1px] bg-[#B2B2B2]"></div>
              <span>{item.title}</span>
              <span className="ml-auto text-[13px] text-[#FF6535]">
                {item.amount} {item.symbol}
              </span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
